import { render, staticRenderFns } from "./EvaluationPage.vue?vue&type=template&id=8e59f9a6&scoped=true"
import script from "./EvaluationPage.vue?vue&type=script&lang=js"
export * from "./EvaluationPage.vue?vue&type=script&lang=js"
import style0 from "./EvaluationPage.vue?vue&type=style&index=0&id=8e59f9a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e59f9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e59f9a6')) {
      api.createRecord('8e59f9a6', component.options)
    } else {
      api.reload('8e59f9a6', component.options)
    }
    module.hot.accept("./EvaluationPage.vue?vue&type=template&id=8e59f9a6&scoped=true", function () {
      api.rerender('8e59f9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/evaluation/EvaluationPage.vue"
export default component.exports